// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { assetSearchListingSchema } from '@/asset/hooks/use-asset-filters';
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { getItem } from '@/items/api/get-item';
import { ItemAssetTable } from '@/items/components/item-asset-table';
import { Stack } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/catalog/items/$itemKey/assets')({
  component: ItemAssetsRoute,
  validateSearch: assetSearchListingSchema,
});

function ItemAssetsRoute() {
  const { itemKey } = Route.useParams();
  const navigate = Route.useNavigate();
  const searchParameters = Route.useSearch();

  const { data } = useSuspenseQuery({
    queryKey: ['item', itemKey],
    queryFn: () => getItem(itemKey),
  });

  const handleChangePage = (pageNumber: number) => {
    navigate({ search: { ...searchParameters, page: pageNumber } });
  };

  // Only DEVICE items (hasAssets) can have related assets
  if (!data.item.hasAssets) {
    return (
      <Navigate to="/catalog/items/$itemKey" params={{ itemKey }} replace />
    );
  }

  return (
    <HardfinTabCardWrapper title="Related assets">
      <Stack paddingTop={2}>
        <ItemAssetTable
          itemId={data.item.id}
          handlePageChange={handleChangePage}
          assetSearchParams={searchParameters}
        />
      </Stack>
    </HardfinTabCardWrapper>
  );
}
